<template>
<div class="open-new-app">
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: $const.route.OPEN_YOUTU_BOX_DISPLAY }">业务申请</el-breadcrumb-item>
    <el-breadcrumb-item>申请优图盒子授权</el-breadcrumb-item>
  </el-breadcrumb>
  <div class="appform">
    <div class="appform__header">
      <div class="title-cont">申请优图盒子授权</div>
    </div>
    <el-form :model="newYoutuBoxData" :rules="rules" ref="newYoutuBoxData" @submit.native.prevent>
        <!-- <el-form-item label="优图接口人邮箱:" prop="youtucontacts" v-show="showInnerTable">
          <el-input v-model="newYoutuBoxData.youtucontacts" placeholder="张三" :maxlength="100"></el-input>
          <div class="label-description">必须有优图商务、架构师等接口人对接，才可申请优图盒子授权，否则无法通过审核。</div>
        </el-form-item> -->
        <el-form-item label="优图接口人邮箱:" prop="ytcontact">
          <el-input v-model="newYoutuBoxData.ytcontact" placeholder="xyz@tencent.com" :maxlength="100"></el-input>
          <div class="label-description">必须有优图商务、架构师等接口人对接，才可申请优图盒子授权，否则无法通过审核。</div>
        </el-form-item>

        <el-form-item label="应用场景:" class="intro-app" prop="scene">
          <el-input
            type="textarea"
            v-model="newYoutuBoxData.scene"
            placeholder="需要说明申请优图盒子的应用场景、需求、功能描述等(600字以内)"
            :maxlength="600">
          </el-input>
        </el-form-item>
        <el-form-item prop="scope" class="form-item-left">
          <bubble
            slot="label"
            class="form-bubble"
            :bubbleInfo="tipConstant.scope">
          </bubble>
          <el-radio-group v-model="newYoutuBoxData.scope">
            <el-radio v-for="mainstayType in OptionMapper.MAINSTAY_TYPE" :label="mainstayType.value" :key="mainstayType.value">{{mainstayType.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="applytype" class="form-item-left">
          <bubble
            slot="label"
            class="form-bubble"
            :bubbleInfo="tipConstant.applytype">
          </bubble>
          <el-radio-group v-model="newYoutuBoxData.applytype">
            <el-radio :label="ApplyType.TEST">测试</el-radio>
            <el-radio :label="ApplyType.PRO">正式</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="`* ${contractText}:`" ref="contract" v-show="newYoutuBoxData.applytype === ApplyType.PRO">
          <bubble
            slot="label"
            class="form-bubble"
            v-if="showInnerTable"
            :bubbleInfo="tipConstant.contract">
          </bubble>
          <form-item-upload-file
            :validateFile="validateFileContract"
            :ErrorName="ErrorNameContract"
            :NeedConfirm="true"
            :noValidate="false"
            :twoM="true"
            @validateInfoResult="handleValidateUploadResultContract($event, false)">
          </form-item-upload-file>
        </el-form-item>
        <el-form-item label="企业名称:" prop="extname" v-show="defaultExternal">
          <el-input v-model="newYoutuBoxData.extname" placeholder="XXXX公司" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="企业网址:" prop="exturl" v-show="defaultExternal">
          <el-input v-model="newYoutuBoxData.exturl" placeholder="www.xxx.com" :maxlength="100"></el-input>
        </el-form-item>

        <el-form-item label="业务所属部门:" prop="intdept" v-show="showInnerTable">
          <el-input v-model="newYoutuBoxData.intdept" placeholder="XXBG/XX部门" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="业务接口人及联系方式:" prop="peercontact">
          <el-input v-model="newYoutuBoxData.peercontact" placeholder="张三, 139......, zhangsan@qq.com" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="业务方邮件列表:" prop="mailreceiver">
          <el-input v-model="newYoutuBoxData.mailreceiver" placeholder="xyz@qq.com" :maxlength="100"></el-input>
          <div class="label-description">授权到期、版本更新和交付等情况都将发送到这些邮箱，请如实填写。</div>
        </el-form-item>
        <el-form-item label="营业执照:" ref="licence" v-show="defaultExternal">
          <form-item-upload-file
            :validateFile="validateFileLicence"
            :ErrorName="ErrorNameLicence"
            :NeedConfirm="true"
            :noValidate="true"
            :twoM="true"
            @validateInfoResult="handleValidateUploadResultLicence($event, true)">
          </form-item-upload-file>
        </el-form-item>
        <el-form-item label="说明:" class="explain-info">
          <div>
            <span>两个工作日内完成审核，审核结果邮箱通知，请至业务申请页面查看审核结果并绑定设备。</span>
            <br/>测试授权时间为申请完成之后起60天，正式授权时间为合同内签署的有效期。
            <br/>测试版提供3台设备的授权，正式版将根据合同确定授权设备数量。</div>
        </el-form-item>
    </el-form>
    <div class="c-btn-add" @click="handleSubmitBox">
      <span class="icon-plus"></span>
      <span class="text">提交申请</span>
    </div>
  </div>
</div>
</template>
<script>
import YoutuBoxCreator from './js/YoutuBoxCreator';
export default YoutuBoxCreator;
</script>
<style lang="less">
@import "./css/youtubox-creator.less";
</style>


// WEBPACK FOOTER //
// src/components/open/panels/application/panels/YoutuBoxCreator.vue